import { get } from 'lodash';

export const MealPlanHelp = {
  template: `
    <div
      id="modalMealPlanHelp"
      class="meal-plan-help modal fade"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="Meal Plan Help"
      aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center mx-1">
            <h5 class="modal-title m-auto">
              How to create a new meal plan
            </h5>
          </div>
          <div class="modal-body container p-0">
            <div class="row no-gutters">
              <div class="col-lg-6">
                <div class="tab-content">
                  <div class="tab-pane active" id="help-1" role="tabpanel">
                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">1. Pick the day you wish to add meals to</h5>
                    <div class="meal-plan-help-img help-1"></div>
                  </div>

                  <div class="tab-pane" id="help-2" role="tabpanel">
                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">2. Search for the meal</h5>
                    <div class="meal-plan-help-img help-2"></div>
                  </div>

                  <div class="tab-pane" id="help-3" role="tabpanel">
                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">3. Click <i class="fa fa-plus-circle"></i> and select number of serves</h5>
                    <div class="meal-plan-help-img help-3"></div>
                  </div>

                  <div class="tab-pane" id="help-4" role="tabpanel">
                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">4. Click Done</h5>
                    <div class="meal-plan-help-img help-4"></div>
                  </div>

                  <div class="tab-pane" id="help-5" role="tabpanel">
                    <h5 class="tab-pane-title d-md-none d-lg-none d-xl-none">Enjoy your Meal Plan and Shopping List</h5>
                    <div class="meal-plan-help-img help-5"></div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 border-left">
                <ul class="nav nav-tabs nav-tabs-vertical" role="tablist">
                  <li class="nav-item">
                    <a href="#help-1" class="nav-link active" data-toggle="tab" role="tab" ng-click="$ctrl.step = 1">
                      1. Pick the day you wish to add meals to
                    </a>
                  </li>

                  <li class="nav-item">
                    <a href="#help-2" class="nav-link" data-toggle="tab" role="tab" ng-click="$ctrl.step = 2">
                      2. Search for the meal
                    </a>
                  </li>

                  <li class="nav-item">
                    <a href="#help-3" class="nav-link" data-toggle="tab" role="tab" ng-click="$ctrl.step = 3">
                      3. Click <i class="fa fa-plus-circle"></i> and select number of serves
                    </a>
                  </li>

                  <li class="nav-item">
                    <a href="#help-4" class="nav-link" data-toggle="tab" role="tab" ng-click="$ctrl.step = 4">
                      4. Click Done
                    </a>
                  </li>

                  <li class="nav-item">
                    <a href="#help-5" class="nav-link" data-toggle="tab" role="tab" ng-click="$ctrl.step = 5">
                      Enjoy your Meal Plan and Shopping List
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button-primary
              size="md"
              data-dismiss="modal"
              is-inverse="true">
              Close
            </button-primary>
            <button-primary
              class="d-none d-md-block"
              size="md"
              is-inverse="true"
              on-click="$ctrl.onHelpNext()"
              ng-if="$ctrl.step !== 5">
              Next
            </button-primary>
            <button-primary
              class="d-none d-md-block"
              data-dismiss="modal"
              size="md"
              ng-if="$ctrl.step === 5">
              Done
            </button-primary>
            <button-primary
              class="d-md-none"
              size="md"
              data-dismiss="modal">
              Done
            </button-primary>
          </div>
        </div>
      </div>
    </div>`,

  controller($element, $timeout) {
    'ngInject';

    return {
      $onInit() {
        this.modal = $element.find('#modalMealPlanHelp');
        this.modal.modal('show');
        this.step = 1;
      },

      onHelpNext() {
        $timeout(() => {
          this.step += 1;
          $element.find(`[href="#help-${this.step}"]`).click();
        });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanHelp.js